// import React, { useEffect, useState } from 'react';
// import { db, auth } from '../firebase';
// import { collection, query, where, getDocs, limit, startAfter } from 'firebase/firestore';
// import { useLocation } from 'react-router-dom';
// import axios from 'axios';
// import '../style/ReturnOrder.css';
// import Sidebar from '../components/Sidebar';
// import Header from '../components/Header';

// const Return = () => {
//     const [deliveredOrders, setDeliveredOrders] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const location = useLocation();
//     const [searchTerm, setSearchTerm] = useState('');
//     const [loadingMore, setLoadingMore] = useState(false);
//     const [noMoreOrders, setNoMoreOrders] = useState(false);
//     const [error, setError] = useState(null);
//     const [filteredOrders, setFilteredOrders] = useState([]);
//     const queryParams = new URLSearchParams(location.search);
//     const shopId = queryParams.get('shop');
//     const [searchLoading, setSearchLoading] = useState(false);
//     const [lastVisible, setLastVisible] = useState(null);
//     const ordersPerPage = 10;

//     // Modal states
//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const [selectedOrder, setSelectedOrder] = useState(null);
//     const [editedOrderData, setEditedOrderData] = useState({});
//     const [selectedItems, setSelectedItems] = useState([]);
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const [returnSuccess, setReturnSuccess] = useState(null);

//     // Date filter states
//     const [fromDate, setFromDate] = useState('');
//     const [toDate, setToDate] = useState('');
    
//     // Payment method filter state
//     const [paymentMethodFilter, setPaymentMethodFilter] = useState('all');

//     const user = auth.currentUser;
//     if (!user) {
//         throw new Error("User not logged in");
//     }

//     const fetchDeliveredOrders = async (isInitialLoad = true) => {
//         try {
//             if (isInitialLoad) {
//                 setLoading(true);
//                 setDeliveredOrders([]);
//                 setError(null);
//             } else {
//                 setLoadingMore(true);
//             }

//             const ordersCollection = collection(db, 'users', user.uid, 'orders');
            
//             // Create a query for orders with status "Delivered"
//             let deliveredQuery;
            
//             if (!isInitialLoad && lastVisible) {
//                 deliveredQuery = query(
//                     ordersCollection, 
//                     where("tracking_status", "==", "DELIVERED"),
//                     startAfter(lastVisible),
//                     limit(ordersPerPage)
//                 );
//             } else {
//                 deliveredQuery = query(
//                     ordersCollection, 
//                     where("tracking_status", "==", "DELIVERED"),
//                     limit(ordersPerPage)
//                 );
//             }
            
//             const ordersSnapshot = await getDocs(deliveredQuery);
            
//             // If no documents returned and not initial load, we've reached the end
//             if (ordersSnapshot.empty && !isInitialLoad) {
//                 setNoMoreOrders(true);
//                 setLoadingMore(false);
//                 return;
//             }

//             if (ordersSnapshot.empty && isInitialLoad) {
//                 setError("No orders found with the specified tracking statuses");
//                 setDeliveredOrders([]);
//                 return;
//             }
            
//             // Update lastVisible for pagination
//             const lastDoc = ordersSnapshot.docs[ordersSnapshot.docs.length - 1];
//             setLastVisible(lastDoc);
            
//             const ordersList = ordersSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            
//             // Append or set orders based on initial load or loading more
//             setDeliveredOrders(prevOrders => (
//                 isInitialLoad ? ordersList : [...prevOrders, ...ordersList]
//             ));
//         } catch (error) {
//             console.error("Error fetching delivered orders:", error);
//             setError(`Error fetching orders: ${error.message}`);
//         } finally {
//             setLoading(false);
//             setLoadingMore(false);
//         }
//     };

//     // For search functionality across all orders
//     const [allOrders, setAllOrders] = useState([]);

//     const fetchAllOrdersForSearch = async () => {
//         if (searchTerm.length >= 3 || fromDate || toDate || paymentMethodFilter !== 'all') {
//             setSearchLoading(true);
//             try {
//                 const ordersCollection = collection(db, 'users', user.uid, 'orders');
//                 // Get all delivered orders and filter on client-side
//                 const q = query(ordersCollection, where("tracking_status", "==", "DELIVERED"));
                
//                 const ordersSnapshot = await getDocs(q);
//                 const allOrdersList = ordersSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
//                 setAllOrders(allOrdersList);
                
//                 // Apply all filters
//                 applyAllFilters(allOrdersList);
//             } catch (error) {
//                 console.error("Error fetching all orders for search:", error);
//                 setError(`Error searching orders: ${error.message}`);
//             } finally {
//                 setSearchLoading(false);
//             }
//         } else if (searchTerm.length === 0 && !fromDate && !toDate && paymentMethodFilter === 'all') {
//             // Reset to paginated view
//             setFilteredOrders(deliveredOrders);
//         }
//     };

//     const applyAllFilters = (orders) => {
//         let filtered = orders;
        
//         // Apply search filter
//         if (searchTerm.length > 0) {
//             filtered = filtered.filter(order => 
//                 order.id.toLowerCase().includes(searchTerm.toLowerCase()) || 
//                 (order.Storeorder_id && order.Storeorder_id.toLowerCase().includes(searchTerm.toLowerCase()))
//             );
//         }
        
//         // Apply date filters if set
//         if (fromDate) {
//             const fromDateTime = new Date(fromDate).getTime();
//             filtered = filtered.filter(order => {
//                 if (!order.order_date) return false;
//                 const orderDate = new Date(order.order_date).getTime();
//                 return orderDate >= fromDateTime;
//             });
//         }
        
//         if (toDate) {
//             const toDateTime = new Date(toDate).setHours(23, 59, 59, 999);
//             filtered = filtered.filter(order => {
//                 if (!order.order_date) return false;
//                 const orderDate = new Date(order.order_date).getTime();
//                 return orderDate <= toDateTime;
//             });
//         }
        
//         // Apply payment method filter
//         if (paymentMethodFilter !== 'all') {
//             filtered = filtered.filter(order => 
//                 order.payment_method === paymentMethodFilter
//             );
//         }
        
//         setFilteredOrders(filtered);
//     };

//     useEffect(() => {
//         fetchDeliveredOrders(true);
//     }, [shopId]);

//     useEffect(() => {
//         if (searchTerm.length >= 3 || fromDate || toDate || paymentMethodFilter !== 'all') {
//             fetchAllOrdersForSearch();
//         } else if (searchTerm.length === 0 && !fromDate && !toDate && paymentMethodFilter === 'all') {
//             setFilteredOrders(deliveredOrders);
//         } else {
//             // For 1-2 characters of search term, just filter the current paginated results
//             applyAllFilters(deliveredOrders);
//         }
//     }, [searchTerm, fromDate, toDate, paymentMethodFilter]);

//     useEffect(() => {
//         if (searchTerm.length === 0 && !fromDate && !toDate && paymentMethodFilter === 'all') {
//             setFilteredOrders(deliveredOrders);
//         } else {
//             applyAllFilters(deliveredOrders);
//         }
//     }, [deliveredOrders]);

//     const handleSearch = (e) => {
//         setSearchTerm(e.target.value);
//     };

//     const handleFromDateChange = (e) => {
//         setFromDate(e.target.value);
//     };

//     const handleToDateChange = (e) => {
//         setToDate(e.target.value);
//     };

//     const handlePaymentMethodChange = (e) => {
//         setPaymentMethodFilter(e.target.value);
//     };

//     const loadMoreOrders = () => {
//         if (!loadingMore && !noMoreOrders) {
//             fetchDeliveredOrders(false);
//         }
//     };

//     // Return order functions
//     const openReturnModal = (order) => {
//         setSelectedOrder(order);
//         setEditedOrderData({ ...order });
//         setSelectedItems([]);
//         setIsModalOpen(true);
//         setReturnSuccess(null);
//     };

//     const closeModal = () => {
//         setIsModalOpen(false);
//         setSelectedOrder(null);
//         setEditedOrderData({});
//         setSelectedItems([]);
//     };

//     const handleOrderDataChange = (field, value) => {
//         setEditedOrderData(prev => ({
//             ...prev,
//             [field]: value
//         }));
//     };

//     const handleItemSelection = (item, isSelected) => {
//         if (isSelected) {
//             setSelectedItems(prev => [...prev, { ...item }]);
//         } else {
//             setSelectedItems(prev => prev.filter(i => i.sku !== item.sku));
//         }
//     };

//     const createReturnOrder = async () => {
//         if (selectedItems.length === 0) {
//             alert("Please select at least one item to return");
//             return;
//         }

//         setIsSubmitting(true);
//         try {
//             // Format the data for the return API
//             const returnOrderData = {
//                 user_uid: user.uid,
//                 id: `R_${selectedOrder.id}`, // Create a unique ID for return
//                 order_date: new Date().toISOString().split('T')[0],
                
//                 // Pickup information (customer's shipping address)
//                 pickup_customer_name: editedOrderData.billing_customer_name,
//                 pickup_last_name: editedOrderData.billing_last_name || "",
//                 pickup_address: editedOrderData.billing_address,
//                 pickup_address_2: editedOrderData.billing_address_2 || "",
//                 pickup_city: editedOrderData.billing_city,
//                 pickup_state: editedOrderData.billing_state,
//                 pickup_country: editedOrderData.billing_country,
//                 pickup_pincode: editedOrderData.billing_pincode,
//                 pickup_email: editedOrderData.billing_email,
//                 pickup_phone: editedOrderData.billing_phone,
                
//                 // Order items - only the selected ones
//                 order_items: selectedItems.map(item => ({
//                     name: item.name,
//                     sku: item.sku,
//                     units: item.units,
//                     selling_price: item.selling_price,
//                 })),
                
//                 payment_method: editedOrderData.payment_method,
//                 sub_total: selectedItems.reduce((total, item) => total + (parseFloat(item.selling_price) * item.units), 0),
                
//                 // Default package dimensions if not provided
//                 length: editedOrderData.length || 10,
//                 breadth: editedOrderData.breadth || 10,
//                 height: editedOrderData.height || 10,
//                 weight: editedOrderData.weight || 0.5,
                
//                 // Original order reference
//                 original_order_id: selectedOrder.id,
//                 shopDomain: selectedOrder.shopDomain || shopId
//             };

//             // Call your API to create a return order
//             const response = await axios.post('http://localhost:8080/create-shiprocket-return-order', returnOrderData);
            
//             console.log('Return order created successfully:', response.data);
//             setReturnSuccess({
//                 message: 'Return order created successfully!',
//                 returnOrderId: response.data.order_id || response.data.channel_order_id
//             });
            
//             // Optional: Refresh the orders list
//             // fetchDeliveredOrders(true);
            
//         } catch (error) {
//             console.error('Error creating return order:', error);
//             setError(`Failed to create return order: ${error.response?.data?.error || error.message}`);
//         } finally {
//             setIsSubmitting(false);
//         }
//     };

//     if (loading) {
//         return <div className="loading-container">Loading Delivered Orders...</div>;
//     }

//     return (
//         <div className="orders-page">
//             <Header />
//             <div className="orders-container">
//                 <Sidebar />
//                 <div className="main-content">
//                     <h1>Book a Return</h1>
//                     <div className="filters-container">
//                         <div className="search-container">
//                             <input 
//                                 type="text" 
//                                 placeholder="Search by Order ID or Store Order ID" 
//                                 value={searchTerm} 
//                                 onChange={handleSearch} 
//                                 className="search-bar"
//                             />
//                             {searchLoading && <span className="search-loader">Searching...</span>}
//                         </div>
                        
//                         <div className="date-filters">
//                             <div className="date-filter">
//                                 <label>From Date:</label>
//                                 <input 
//                                     type="date" 
//                                     value={fromDate} 
//                                     onChange={handleFromDateChange}
//                                 />
//                             </div>
//                             <div className="date-filter">
//                                 <label>To Date:</label>
//                                 <input 
//                                     type="date" 
//                                     value={toDate} 
//                                     onChange={handleToDateChange}
//                                 />
//                             </div>
//                         </div>
                        
//                         <div className="payment-filter">
//                             <label>Payment Method:</label>
//                             <select 
//                                 value={paymentMethodFilter} 
//                                 onChange={handlePaymentMethodChange}
//                             >
//                                 <option value="all">All</option>
//                                 <option value="COD">COD</option>
//                                 <option value="Prepaid">Prepaid</option>
//                             </select>
//                         </div>
//                     </div>
                    
//                     {error && (
//                         <div className="error-message">
//                             {error}
//                         </div>
//                     )}
                    
//                     {filteredOrders.length > 0 ? (
//                         <table className="orders-table">
//                             <thead>
//                                 <tr>
//                                     <th>Order ID</th>
//                                     <th>Unitee Order ID</th>
//                                     <th>SKU</th>
//                                     <th>Quantity</th>
//                                     <th>Order Date</th>
//                                     <th>Payment Method</th>
//                                     <th>Total Order Value</th>
//                                     <th>Current Status</th>
//                                     <th>Action</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {filteredOrders.map(order => (
//                                     <tr key={order.id}>
//                                         <td>{order.Storeorder_id || 'NA'}</td>
//                                         <td>{order.id || 'NA'}</td>
//                                         <td>
//                                             {order.order_items && order.order_items.map ? (
//                                                 order.order_items.map((item, index) => (
//                                                     <p key={index}>{item.sku}</p>
//                                                 ))
//                                             ) : (
//                                                 <p>No items found</p>
//                                             )}
//                                         </td>
//                                         <td>
//                                             {order.order_items && order.order_items.map ? (
//                                                 order.order_items.map((item, index) => (
//                                                     <p key={index}>{item.units}</p>
//                                                 ))
//                                             ) : (
//                                                 <p>No items found</p>
//                                             )}
//                                         </td>
//                                         <td>{order.order_date ? new Date(order.order_date).toLocaleDateString() : 'NA'}</td>
//                                         <td>{order.payment_method || 'NA'}</td>
//                                         <td>{order.total || 'NA'}</td>
//                                         <td>{order.tracking_status || 'NA'}</td>
//                                         <td>
//                                             <button 
//                                                 className="create-return-btn"
//                                                 onClick={() => openReturnModal(order)}
//                                             >
//                                                 Create Return
//                                             </button>
//                                         </td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     ) : (
//                         <div className="no-orders">
//                             {error ? null : "No orders found with the specified criteria"}
//                         </div>
//                     )}
                    
//                     {searchTerm.length === 0 && !fromDate && !toDate && paymentMethodFilter === 'all' && !noMoreOrders && deliveredOrders.length > 0 && (
//                         <div className="load-more-container">
//                             <button 
//                                 onClick={loadMoreOrders} 
//                                 disabled={loadingMore}
//                                 className="load-more-button"
//                             >
//                                 {loadingMore ? 'Loading...' : 'Load More'}
//                             </button>
//                         </div>
//                     )}
                    
//                     {searchTerm.length === 0 && !fromDate && !toDate && paymentMethodFilter === 'all' && noMoreOrders && deliveredOrders.length > 0 && (
//                         <div className="no-more-orders">No more orders to load</div>
//                     )}
//                 </div>
//             </div>

//             {/* Return Order Modal */}
//             {isModalOpen && selectedOrder && (
//                 <div className="rmodal-overlay">
//                     <div className="rmodal-content">
//                         <div className="rmodal-header">
//                             <h2>Create Return Order</h2>
//                             <button className="rclose-btn" onClick={closeModal}>×</button>
//                         </div>
                        
//                         {returnSuccess ? (
//                             <div className="rmodal-body">
//                                 <div className="success-message">
//                                     <h3>{returnSuccess.message}</h3>
//                                     <p>Return Order ID: {returnSuccess.returnOrderId}</p>
//                                     <button className="ok-btn" onClick={closeModal}>OK</button>
//                                 </div>
//                             </div>
//                         ) : (
//                             <>
//                                 <div className="rmodal-body">
//                                     <div className="form-group">
//                                         <label>Store Order ID:</label>
//                                         <input 
//                                             type="text" 
//                                             value={editedOrderData.Storeorder_id || ''} 
//                                             readOnly
//                                         />
//                                     </div>
                                    
//                                     <div className="form-group">
//                                         <label>Unitee Order ID:</label>
//                                         <span>{selectedOrder.id}</span>
//                                     </div>
                                    
//                                     <h3>Pickup Information (Customer Details)</h3>
//                                     <div className="form-row">
//                                         <div className="form-group">
//                                             <label>Customer Name:</label>
//                                             <input 
//                                                 type="text" 
//                                                 value={editedOrderData.billing_customer_name || ''} 
//                                                 onChange={(e) => handleOrderDataChange('billing_customer_name', e.target.value)}
//                                             />
//                                         </div>
                                        
//                                         <div className="form-group">
//                                             <label>Last Name:</label>
//                                             <input 
//                                                 type="text" 
//                                                 value={editedOrderData.billing_last_name || ''} 
//                                                 onChange={(e) => handleOrderDataChange('billing_last_name', e.target.value)}
//                                             />
//                                         </div>
//                                     </div>
                                    
//                                     <div className="form-row">
//                                         <div className="form-group">
//                                             <label>Email:</label>
//                                             <input 
//                                                 type="email" 
//                                                 value={editedOrderData.billing_email || ''} 
//                                                 onChange={(e) => handleOrderDataChange('billing_email', e.target.value)}
//                                             />
//                                         </div>
                                        
//                                         <div className="form-group">
//                                             <label>Phone:</label>
//                                             <input 
//                                                 type="text" 
//                                                 value={editedOrderData.billing_phone || ''} 
//                                                 onChange={(e) => handleOrderDataChange('billing_phone', e.target.value)}
//                                             />
//                                         </div>
//                                     </div>
                                    
//                                     <div className="form-group">
//                                         <label>Address:</label>
//                                         <input 
//                                             type="text" 
//                                             value={editedOrderData.billing_address || ''} 
//                                             onChange={(e) => handleOrderDataChange('billing_address', e.target.value)}
//                                         />
//                                     </div>
                                    
//                                     <div className="form-row">
//                                         <div className="form-group">
//                                             <label>City:</label>
//                                             <input 
//                                                 type="text" 
//                                                 value={editedOrderData.billing_city || ''} 
//                                                 onChange={(e) => handleOrderDataChange('billing_city', e.target.value)}
//                                             />
//                                         </div>
                                        
//                                         <div className="form-group">
//                                             <label>State:</label>
//                                             <input 
//                                                 type="text" 
//                                                 value={editedOrderData.billing_state || ''} 
//                                                 onChange={(e) => handleOrderDataChange('billing_state', e.target.value)}
//                                             />
//                                         </div>
//                                     </div>
                                    
//                                     <div className="form-row">
//                                         <div className="form-group">
//                                             <label>Pincode:</label>
//                                             <input 
//                                                 type="text" 
//                                                 value={editedOrderData.billing_pincode || ''} 
//                                                 onChange={(e) => handleOrderDataChange('billing_pincode', e.target.value)}
//                                             />
//                                         </div>
                                        
//                                         <div className="form-group">
//                                             <label>Country:</label>
//                                             <input 
//                                                 type="text" 
//                                                 value={editedOrderData.billing_country || ''} 
//                                                 onChange={(e) => handleOrderDataChange('billing_country', e.target.value)}
//                                             />
//                                         </div>
//                                     </div>
                                    
//                                     <div className="form-group">
//                                         <label>Payment Method:</label>
//                                         <input 
//                                             type="text" 
//                                             value={editedOrderData.payment_method || ''} 
//                                             readOnly
//                                         />
//                                     </div>
                                    
//                                     <h3>Select Items for Return</h3>
//                                     {editedOrderData.order_items?.map((item, index) => (
//                                         <div key={index} className="order-item">
//                                             <div className="item-select">
//                                                 <input 
//                                                     type="checkbox" 
//                                                     id={`item-${index}`}
//                                                     onChange={(e) => handleItemSelection(item, e.target.checked)}
//                                                     checked={selectedItems.some(i => i.sku === item.sku)}
//                                                 />
//                                                 <label htmlFor={`item-${index}`}>Select for Return</label>
//                                             </div>
                                            
//                                             <h4>Item {index + 1}</h4>
//                                             <div className="form-row">
//                                                 <div className="form-group">
//                                                     <label>SKU:</label>
//                                                     <input 
//                                                         type="text" 
//                                                         value={item.sku || ''} 
//                                                         readOnly
//                                                     />
//                                                 </div>
                                                
//                                                 <div className="form-group">
//                                                     <label>Name:</label>
//                                                     <input 
//                                                         type="text" 
//                                                         value={item.name || ''} 
//                                                         readOnly
//                                                     />
//                                                 </div>
//                                             </div>
                                            
//                                             <div className="form-row">
//                                                 <div className="form-group">
//                                                     <label>Units:</label>
//                                                     <input 
//                                                         type="number" 
//                                                         value={item.units || 0} 
//                                                         readOnly
//                                                     />
//                                                 </div>
                                                
//                                                 <div className="form-group">
//                                                     <label>Price:</label>
//                                                     <input 
//                                                         type="text" 
//                                                         value={item.selling_price || ''} 
//                                                         readOnly
//                                                     />
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     ))}
                                    
//                                     <div className="selected-items-summary">
//                                         <h4>Selected Items: {selectedItems.length}</h4>
//                                         <p>Total Value: ₹{selectedItems.reduce((total, item) => total + (parseFloat(item.selling_price) * item.units), 0).toFixed(2)}</p>
//                                     </div>
//                                 </div>
                                
//                                 <div className="rmodal-footer">
//                                     <button className="cancel-btn" onClick={closeModal}>Cancel</button>
//                                     <button 
//                                         className="save-btn" 
//                                         onClick={createReturnOrder}
//                                         disabled={isSubmitting || selectedItems.length === 0}
//                                     >
//                                         {isSubmitting ? 'Processing...' : 'Create Return Order'}
//                                     </button>
//                                 </div>
//                             </>
//                         )}
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Return;


import React, { useEffect, useState } from 'react';
import { db, auth } from '../firebase';
import { collection, query, where, getDocs, limit, startAfter, getDoc, addDoc, updateDoc, doc as firestoreDoc, Timestamp } from 'firebase/firestore';
import { useLocation } from 'react-router-dom';
import { Storage } from '../firebase';
import axios from 'axios';
import '../style/ReturnOrder.css';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import { ToastContainer, toast } from 'react-toastify';
import { Link } from 'react-router-dom';

import { jsPDF } from 'jspdf';
import autoTable from "jspdf-autotable";
import { ref, uploadBytesResumable, getDownloadURL, listAll, uploadBytes } from 'firebase/storage';

const Return = () => {
    // Existing state variables
    const [loading, setLoading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [searchLoading, setSearchLoading] = useState(false);
    const [error, setError] = useState(null);
    const [deliveredOrders, setDeliveredOrders] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [lastVisible, setLastVisible] = useState(null);
    const [noMoreOrders, setNoMoreOrders] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [paymentMethodFilter, setPaymentMethodFilter] = useState('all');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [editedOrderData, setEditedOrderData] = useState({});
    const [selectedItems, setSelectedItems] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [returnSuccess, setReturnSuccess] = useState(null);
    const ordersPerPage = 10;
    
    // New state variables for wallet and confirmation
    const [walletBalance, setWalletBalance] = useState(0);
    const [confirmBalance, setConfirmBalance] = useState(0);
    const [showConfirmModal, setShowConfirmModal] = useState(false);

      const user = auth.currentUser;
        if (!user) {
            throw new Error("User not logged in");
        }
    
    const userId = user?.uid;
    const RETURN_COST = 100;
    const TAX_RATE = 0.18;
    const TOTAL_COST = RETURN_COST + (RETURN_COST * TAX_RATE);

    const fetchDeliveredOrders = async (isInitialLoad = true) => {
        try {
            if (isInitialLoad) {
                setLoading(true);
                setDeliveredOrders([]);
                setError(null);
            } else {
                setLoadingMore(true);
            }

            const ordersCollection = collection(db, 'users', user.uid, 'orders');
            
            // Create a query for orders with status "Delivered"
            let deliveredQuery;
            
            if (!isInitialLoad && lastVisible) {
                deliveredQuery = query(
                    ordersCollection, 
                    where("tracking_status", "==", "DELIVERED"),
                    startAfter(lastVisible),
                    limit(ordersPerPage)
                );
            } else {
                deliveredQuery = query(
                    ordersCollection, 
                    where("tracking_status", "==", "DELIVERED"),
                    limit(ordersPerPage)
                );
            }
            
            const ordersSnapshot = await getDocs(deliveredQuery);
            
            // If no documents returned and not initial load, we've reached the end
            if (ordersSnapshot.empty && !isInitialLoad) {
                setNoMoreOrders(true);
                setLoadingMore(false);
                return;
            }

            if (ordersSnapshot.empty && isInitialLoad) {
                setError("No orders found with the specified tracking statuses");
                setDeliveredOrders([]);
                return;
            }
            
            // Update lastVisible for pagination
            const lastDoc = ordersSnapshot.docs[ordersSnapshot.docs.length - 1];
            setLastVisible(lastDoc);
            
            const ordersList = ordersSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            
            // Append or set orders based on initial load or loading more
            setDeliveredOrders(prevOrders => (
                isInitialLoad ? ordersList : [...prevOrders, ...ordersList]
            ));
        } catch (error) {
            console.error("Error fetching delivered orders:", error);
            setError(`Error fetching orders: ${error.message}`);
        } finally {
            setLoading(false);
            setLoadingMore(false);
        }
    };

    // For search functionality across all orders
    const [allOrders, setAllOrders] = useState([]);

    const fetchAllOrdersForSearch = async () => {
        if (searchTerm.length >= 3 || fromDate || toDate || paymentMethodFilter !== 'all') {
            setSearchLoading(true);
            try {
                const ordersCollection = collection(db, 'users', user.uid, 'orders');
                // Get all delivered orders and filter on client-side
                const q = query(ordersCollection, where("tracking_status", "==", "DELIVERED"));
                
                const ordersSnapshot = await getDocs(q);
                const allOrdersList = ordersSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setAllOrders(allOrdersList);
                
                // Apply all filters
                applyAllFilters(allOrdersList);
            } catch (error) {
                console.error("Error fetching all orders for search:", error);
                setError(`Error searching orders: ${error.message}`);
            } finally {
                setSearchLoading(false);
            }
        } else if (searchTerm.length === 0 && !fromDate && !toDate && paymentMethodFilter === 'all') {
            // Reset to paginated view
            setFilteredOrders(deliveredOrders);
        }
    };

    const applyAllFilters = (orders) => {
        let filtered = orders;
        
        // Apply search filter
        if (searchTerm.length > 0) {
            filtered = filtered.filter(order => 
                order.id.toLowerCase().includes(searchTerm.toLowerCase()) || 
                (order.Storeorder_id && order.Storeorder_id.toLowerCase().includes(searchTerm.toLowerCase()))
            );
        }
        
        // Apply date filters if set
        if (fromDate) {
            const fromDateTime = new Date(fromDate).getTime();
            filtered = filtered.filter(order => {
                if (!order.order_date) return false;
                const orderDate = new Date(order.order_date).getTime();
                return orderDate >= fromDateTime;
            });
        }
        
        if (toDate) {
            const toDateTime = new Date(toDate).setHours(23, 59, 59, 999);
            filtered = filtered.filter(order => {
                if (!order.order_date) return false;
                const orderDate = new Date(order.order_date).getTime();
                return orderDate <= toDateTime;
            });
        }
        
        // Apply payment method filter
        if (paymentMethodFilter !== 'all') {
            filtered = filtered.filter(order => 
                order.payment_method === paymentMethodFilter
            );
        }
        
        setFilteredOrders(filtered);
    };

    useEffect(() => {
        fetchDeliveredOrders(true);
    }, [userId]);

    // New useEffect for fetching wallet balance
    useEffect(() => {
        const fetchWalletBalance = async () => {
            if (!userId) return;
            
            try {
                const walletRef = firestoreDoc(db, 'users', userId, 'wallet', 'walletDetails');
                const walletSnap = await getDoc(walletRef);
                if (walletSnap.exists()) {
                    const walletData = walletSnap.data();
                    setWalletBalance(walletData.balance);
                } else {
                    toast.error('Wallet not found. Please recharge.');
                }
            } catch (error) {
                console.error('Error fetching wallet balance:', error);
                toast.error('Error fetching wallet balance.');
            }
        };
        
        fetchWalletBalance();
    }, [userId]);

    useEffect(() => {
        if (searchTerm.length >= 3 || fromDate || toDate || paymentMethodFilter !== 'all') {
            fetchAllOrdersForSearch();
        } else if (searchTerm.length === 0 && !fromDate && !toDate && paymentMethodFilter === 'all') {
            setFilteredOrders(deliveredOrders);
        } else {
            // For 1-2 characters of search term, just filter the current paginated results
            applyAllFilters(deliveredOrders);
        }
    }, [searchTerm, fromDate, toDate, paymentMethodFilter]);

    useEffect(() => {
        if (searchTerm.length === 0 && !fromDate && !toDate && paymentMethodFilter === 'all') {
            setFilteredOrders(deliveredOrders);
        } else {
            applyAllFilters(deliveredOrders);
        }
    }, [deliveredOrders]);

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleFromDateChange = (e) => {
        setFromDate(e.target.value);
    };

    const handleToDateChange = (e) => {
        setToDate(e.target.value);
    };

    const handlePaymentMethodChange = (e) => {
        setPaymentMethodFilter(e.target.value);
    };

    const loadMoreOrders = () => {
        if (!loadingMore && !noMoreOrders) {
            fetchDeliveredOrders(false);
        }
    };

    // Return order functions
    const openReturnModal = (order) => {
        setSelectedOrder(order);
        setEditedOrderData({ ...order });
        setSelectedItems([]);
        setIsModalOpen(true);
        setReturnSuccess(null);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedOrder(null);
        setEditedOrderData({});
        setSelectedItems([]);
    };

    const closeConfirmModal = () => {
        setShowConfirmModal(false);
    };

    const handleOrderDataChange = (field, value) => {
        setEditedOrderData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleItemSelection = (item, isSelected) => {
        if (isSelected) {
            setSelectedItems(prev => [...prev, { ...item }]);
        } else {
            setSelectedItems(prev => prev.filter(i => i.sku !== item.sku));
        }
    };

    // Modified to show confirmation modal instead of directly creating return order
    const initiateReturnOrder = () => {
        if (selectedItems.length === 0) {
            alert("Please select at least one item to return");
            return;
        }
        
        if (walletBalance < TOTAL_COST) {
            toast.error('Insufficient balance. Recharge your wallet.', { 
                onClose: () => setIsModalOpen(true) 
            });
            return;
        }
        
        // Set balance after deduction and show confirmation modal
        setConfirmBalance(walletBalance - TOTAL_COST);
        setShowConfirmModal(true);
    };

    // const createReturnOrder = async () => {
    //     setIsSubmitting(true);
    //     try {
    //         // Format the data for the return API
    //         const returnOrderData = {
    //             user_uid: user.uid,
    //             id: `R_${selectedOrder.id}`, // Create a unique ID for return
    //             order_date: new Date().toISOString().split('T')[0],
                
    //             // Pickup information (customer's shipping address)
    //             pickup_customer_name: editedOrderData.billing_customer_name,
    //             pickup_last_name: editedOrderData.billing_last_name || "",
    //             pickup_address: editedOrderData.billing_address,
    //             pickup_address_2: editedOrderData.billing_address_2 || "",
    //             pickup_city: editedOrderData.billing_city,
    //             pickup_state: editedOrderData.billing_state,
    //             pickup_country: editedOrderData.billing_country,
    //             pickup_pincode: editedOrderData.billing_pincode,
    //             pickup_email: editedOrderData.billing_email,
    //             pickup_phone: editedOrderData.billing_phone,
                
    //             // Order items - only the selected ones
    //             order_items: selectedItems.map(item => ({
    //                 name: item.name,
    //                 sku: item.sku,
    //                 units: item.units,
    //                 selling_price: item.selling_price,
    //             })),
                
    //             payment_method: editedOrderData.payment_method,
    //             sub_total: selectedItems.reduce((total, item) => total + (parseFloat(item.selling_price) * item.units), 0),
                
    //             // Default package dimensions if not provided
    //             length: editedOrderData.length || 10,
    //             breadth: editedOrderData.breadth || 10,
    //             height: editedOrderData.height || 10,
    //             weight: editedOrderData.weight || 0.5,
                
    //             // Original order reference
    //             original_order_id: selectedOrder.id,
    //             shopDomain: selectedOrder.shopDomain
    //         };

    //         // Call your API to create a return order
    //         const response = await axios.post('http://localhost:8080/create-shiprocket-return-order', returnOrderData);
            
    //         console.log('Return order created successfully:', response.data);
            
    //         // Update wallet balance and record transaction
    //         const walletRef = doc(db, 'users', user.uid, 'wallet', 'walletDetails');
    //         await updateDoc(walletRef, { balance: confirmBalance });
            
    //         // Record transaction
    //         const transactionsRef = collection(walletRef, 'transactions');
    //         const transactionData = {
    //             type: `Return_${selectedOrder.id}`,
    //             amount: TOTAL_COST,
    //             balanceBefore: walletBalance,
    //             balanceAfter: confirmBalance,
    //             timestamp: Timestamp.now(),
    //         };
    //         await addDoc(transactionsRef, transactionData);
            
    //         setReturnSuccess({
    //             message: 'Return order created successfully!',
    //             returnOrderId: response.data.order_id || response.data.channel_order_id
    //         });
            
    //         toast.success("Return order created successfully!");
    //         setShowConfirmModal(false);
            
    //     } catch (error) {
    //         console.error('Error creating return order:', error);
        
    //         // Close the confirmation modal
    //         setShowConfirmModal(false);
    //         setIsModalOpen(false)
            
    //         // Show error in toast notification instead of setting error state
    //         toast.error(`Failed to create return order: ${error.response?.data?.error || error.message}`);
    //     } finally {
    //         setIsSubmitting(false);
    //     }
    // };



    const createReturnOrder = async () => {
        setIsSubmitting(true);
        try {
            // Format the data for the return API
            const returnOrderData = {
                user_uid: user.uid,
                id: `R_${selectedOrder.id}`, // Create a unique ID for return
                order_date: new Date().toISOString().split('T')[0],
                
                // Pickup information (customer's shipping address)
                pickup_customer_name: editedOrderData.billing_customer_name,
                pickup_last_name: editedOrderData.billing_last_name || "",
                pickup_address: editedOrderData.billing_address,
                pickup_address_2: editedOrderData.billing_address_2 || "",
                pickup_city: editedOrderData.billing_city,
                pickup_state: editedOrderData.billing_state,
                pickup_country: editedOrderData.billing_country,
                pickup_pincode: editedOrderData.billing_pincode,
                pickup_email: editedOrderData.billing_email,
                pickup_phone: editedOrderData.billing_phone,
                
                // Order items - only the selected ones
                order_items: selectedItems.map(item => ({
                    name: item.name,
                    sku: item.sku,
                    units: item.units,
                    selling_price: item.selling_price,
                })),
                
                payment_method: editedOrderData.payment_method,
                sub_total: selectedItems.reduce((total, item) => total + (parseFloat(item.selling_price) * item.units), 0),
                
                // Default package dimensions if not provided
                length: editedOrderData.length || 10,
                breadth: editedOrderData.breadth || 10,
                height: editedOrderData.height || 10,
                weight: editedOrderData.weight || 0.5,
                
                // Original order reference
                original_order_id: selectedOrder.id,
                shopDomain: selectedOrder.shopDomain
            };
    
            // Generate invoice for the return shipping charges
            const invoiceUrl = await generateReturnInvoice({
                userData: user,
                returnOrderId: `R_${selectedOrder.id}`,
                returnCost: RETURN_COST,
                taxRate: TAX_RATE,
                totalCost: TOTAL_COST
            });
            
            // Add invoice URL to return order data
            returnOrderData.invoiceUrl = invoiceUrl;
    
            // Call your API to create a return order
            const response = await axios.post('https://ufb-1.onrender.com/create-shiprocket-return-order', returnOrderData);
            
            console.log('Return order created successfully:', response.data);
            
            // Update wallet balance and record transaction
            const walletRef = firestoreDoc(db, 'users', user.uid, 'wallet', 'walletDetails');
            await updateDoc(walletRef, { balance: confirmBalance });
            
            // Record transaction
            const transactionsRef = collection(walletRef, 'transactions');
            const transactionData = {
                type: `Return_${selectedOrder.id}`,
                amount: TOTAL_COST,
                balanceBefore: walletBalance,
                balanceAfter: confirmBalance,
                timestamp: Timestamp.now(),
                // invoiceUrl: invoiceUrl
            };
            await addDoc(transactionsRef, transactionData);
            
            setReturnSuccess({
                message: 'Return order created successfully!',
                returnOrderId: response.data.order_id || response.data.channel_order_id,
                invoiceUrl: invoiceUrl
            });
            
            toast.success("Order submitted successfully!");
            setShowConfirmModal(false);
            
        } catch (error) {
            console.error('Error creating return order:', error);
            
            // Close the confirmation modal
            setShowConfirmModal(false);
            
            // Show error in toast notification instead of setting error state
            toast.error(`Failed to create return order: ${error.response?.data?.error || error.message}`);
        } finally {
            setIsSubmitting(false);
        }
    };


         

     
    // Function to generate invoice PDF and upload to storage
    const generateReturnInvoice = async ({returnOrderId, returnCost, taxRate, totalCost }) => {
        try {
            // Import jsPDF if not already imported
            // const { jsPDF } = window.jspdf;
            

            const userRef = firestoreDoc(db, "users", user.uid);
            // Add await here to get the document snapshot
            const userSnap = await getDoc(userRef);
            
            if (!userSnap.exists()) {
              console.error("Brand information not found.");
              return;
            }
            const userData = userSnap.data();
        
            // Create a new PDF document
            const doc = new jsPDF();
            
            // Set up invoice data
            const invoiceDate = new Date().toLocaleDateString();
            const invoiceNumber = `INV-${returnOrderId}`;
            
            // Tax Invoice Title
            doc.setFontSize(20);
            doc.text('TAX INVOICE', 100, 15, null, null, 'center');
            
            // Company Information
            doc.setFontSize(10);
            doc.setFont("Helvetica", "normal");
            doc.text("UNITEE STUDIOS PRIVATE LIMITED", 10, 20);
            doc.text("Maharashtra, India", 10, 25);
            doc.text("GSTIN 27AADCU3575G1Z5", 10, 30);
            doc.text("rajprit@uniteeculture.com", 10, 35);
            doc.text("1ST FLOOR, PLOT 304/E/, 3, WAKHARIA BUILDING Vithalbhai Patel Road", 10, 40);
            doc.text("MUMBAI", 10, 45);
            
            // Invoice Details
            doc.text("Invoice Details", 150, 25, null, null, 'center');
            doc.setFontSize(10);
            doc.text(`Invoice Date: ${invoiceDate}`, 140, 30);
            doc.text(`Invoice Number: ${invoiceNumber}`, 140, 35);
            
            // Billing Information
            doc.text("Bill To", 10, 60);
            doc.text(`Name: ${userData.brandName || userData.displayName || 'Customer'}`, 10, 65);
            doc.text(`Address: ${userData.address || 'N/A'}`, 10, 70);
            doc.text(`State: ${userData.state || 'N/A'}`, 10, 75);
            doc.text(`Pin Code: ${userData.pincode || 'N/A'}`, 10, 80);
            doc.text(`GST Number: ${userData.gstNumber || 'N/A'}`, 10, 85);
            
            // Order details header
            doc.setLineWidth(0.1);
            doc.line(10, 95, 200, 95);
            
            doc.setFontSize(12);
            doc.text("Service Description", 15, 100);
            doc.text("Amount (₹)", 160, 100);
            
            doc.line(10, 105, 200, 105);
            doc.setFontSize(10);
            
            // Return shipping charge details
            doc.text("Return Shipping Charge", 15, 115);
            doc.text(returnCost.toFixed(2), 160, 115);
            
            doc.text("GST (18%)", 15, 125);
            doc.text((returnCost * taxRate).toFixed(2), 160, 125);
            
            doc.line(10, 135, 200, 135);
            
            // Total
            doc.setFontSize(12);
            doc.text("Total", 15, 145);
            doc.text(totalCost.toFixed(2), 160, 145);
            
            doc.line(10, 150, 200, 150);
            
            // Additional notes
            doc.setFontSize(9);
            doc.text("This is a computer generated invoice, no signature required.", 10, 170);
            doc.text(`Return Order ID: ${returnOrderId}`, 10, 175);
            doc.text("For any queries, please contact support@uniteeculture.com", 10, 180);
            
            // Generate blob from PDF
            const pdfBlob = doc.output('blob');
            
            // Create a reference to Firebase Storage
            const storageRef = ref(Storage, `invoices/returns/${returnOrderId}_${Date.now()}.pdf`);
            
            // Upload PDF to Firebase Storage
            const uploadTask = await uploadBytes(storageRef, pdfBlob);
            
            // Get download URL
            const downloadUrl = await getDownloadURL(uploadTask.ref);
            
            console.log('Invoice generated and uploaded:', downloadUrl);
            
            return downloadUrl;
        } catch (error) {
            console.error('Error generating invoice:', error);
            toast.error('Failed to generate invoice, but return order was created');
            return null;
        }
    };

    if (loading) {
        return <div className="loading-container">Loading Delivered Orders...</div>;
    }

    return (
        <div className="orders-page">
            <Header />
            <div className="orders-container">
                <Sidebar />
                <div className="main-content">
                    <h1>Book a Return</h1>
                    <div className="filters-container">
                        <div className="search-container">
                            <input 
                                type="text" 
                                placeholder="Search by Order ID or Store Order ID" 
                                value={searchTerm} 
                                onChange={handleSearch} 
                                className="search-bar"
                            />
                            {searchLoading && <span className="search-loader">Searching...</span>}
                        </div>
                        
                        <div className="date-filters">
                            <div className="date-filter">
                                <label>From Date:</label>
                                <input 
                                    type="date" 
                                    value={fromDate} 
                                    onChange={handleFromDateChange}
                                />
                            </div>
                            <div className="date-filter">
                                <label>To Date:</label>
                                <input 
                                    type="date" 
                                    value={toDate} 
                                    onChange={handleToDateChange}
                                />
                            </div>
                        </div>
                        
                        <div className="payment-filter">
                            <label>Payment Method:</label>
                            <select 
                                value={paymentMethodFilter} 
                                onChange={handlePaymentMethodChange}
                            >
                                <option value="all">All</option>
                                <option value="COD">COD</option>
                                <option value="Prepaid">Prepaid</option>
                            </select>
                        </div>
                    </div>
                    
                    {error && (
                        <div className="error-message">
                            {error}
                        </div>
                    )}
                    
                    {filteredOrders.length > 0 ? (
                        <table className="orders-table">
                            <thead>
                                <tr>
                                    <th>Order ID</th>
                                    <th>Unitee Order ID</th>
                                    <th>SKU</th>
                                    <th>Quantity</th>
                                    <th>Order Date</th>
                                    <th>Payment Method</th>
                                    <th>Total Order Value</th>
                                    <th>Current Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredOrders.map(order => (
                                    <tr key={order.id}>
                                        <td>{order.Storeorder_id || 'NA'}</td>
                                        <td>{order.id || 'NA'}</td>
                                        <td>
                                            {order.order_items && order.order_items.map ? (
                                                order.order_items.map((item, index) => (
                                                    <p key={index}>{item.sku}</p>
                                                ))
                                            ) : (
                                                <p>No items found</p>
                                            )}
                                        </td>
                                        <td>
                                            {order.order_items && order.order_items.map ? (
                                                order.order_items.map((item, index) => (
                                                    <p key={index}>{item.units}</p>
                                                ))
                                            ) : (
                                                <p>No items found</p>
                                            )}
                                        </td>
                                        <td>{order.order_date ? new Date(order.order_date).toLocaleDateString() : 'NA'}</td>
                                        <td>{order.payment_method || 'NA'}</td>
                                        <td>{order.total || 'NA'}</td>
                                        <td>{order.tracking_status || 'NA'}</td>
                                        <td>
                                            <button 
                                                className="create-return-btn"
                                                onClick={() => openReturnModal(order)}
                                            >
                                                Create Return
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <div className="no-orders">
                            {error ? null : "No orders found with the specified criteria"}
                        </div>
                    )}
                    
                    {searchTerm.length === 0 && !fromDate && !toDate && paymentMethodFilter === 'all' && !noMoreOrders && deliveredOrders.length > 0 && (
                        <div className="load-more-container">
                            <button 
                                onClick={loadMoreOrders} 
                                disabled={loadingMore}
                                className="load-more-button"
                            >
                                {loadingMore ? 'Loading...' : 'Load More'}
                            </button>
                        </div>
                    )}
                    
                    {searchTerm.length === 0 && !fromDate && !toDate && paymentMethodFilter === 'all' && noMoreOrders && deliveredOrders.length > 0 && (
                        <div className="no-more-orders">No more orders to load</div>
                    )}
                </div>
            </div>

            {/* Return Order Modal */}
            {isModalOpen && selectedOrder && (
                <div className="rmodal-overlay">
                    <div className="rmodal-content">
                        <div className="rmodal-header">
                            <h2>Create Return Order</h2>
                            <button className="rclose-btn" onClick={closeModal}>×</button>
                        </div>
                        
                        {returnSuccess ? (
                            <div className="rmodal-body">
                                <div className="success-message">
                                    <h3>{returnSuccess.message}</h3>
                                    <p>Return Order ID: {returnSuccess.returnOrderId}</p>
                                  <button>  <Link to="/Return-Orders" className="ok-btn">
                                      Go to Return Orders Page
                                         </Link>
                                         </button>
                                </div>
                            </div>
                        ) : (
                            <>
                                <div className="rmodal-body">
                                    <div className="form-group">
                                        <label>Store Order ID:</label>
                                        <input 
                                            type="text" 
                                            value={editedOrderData.Storeorder_id || ''} 
                                            readOnly
                                        />
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Unitee Order ID:</label>
                                        <span>{selectedOrder.id}</span>
                                    </div>
                                    
                                    <h3>Pickup Information (Customer Details)</h3>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Customer Name:</label>
                                            <input 
                                                type="text" 
                                                value={editedOrderData.billing_customer_name || ''} 
                                                onChange={(e) => handleOrderDataChange('billing_customer_name', e.target.value)}
                                            />
                                        </div>
                                        
                                        <div className="form-group">
                                            <label>Last Name:</label>
                                            <input 
                                                type="text" 
                                                value={editedOrderData.billing_last_name || ''} 
                                                onChange={(e) => handleOrderDataChange('billing_last_name', e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Email:</label>
                                            <input 
                                                type="email" 
                                                value={editedOrderData.billing_email || ''} 
                                                onChange={(e) => handleOrderDataChange('billing_email', e.target.value)}
                                            />
                                        </div>
                                        
                                        <div className="form-group">
                                            <label>Phone:</label>
                                            <input 
                                                type="text" 
                                                value={editedOrderData.billing_phone || ''} 
                                                onChange={(e) => handleOrderDataChange('billing_phone', e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Address:</label>
                                        <input 
                                            type="text" 
                                            value={editedOrderData.billing_address || ''} 
                                            onChange={(e) => handleOrderDataChange('billing_address', e.target.value)}
                                        />
                                    </div>
                                    
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>City:</label>
                                            <input 
                                                type="text" 
                                                value={editedOrderData.billing_city || ''} 
                                                onChange={(e) => handleOrderDataChange('billing_city', e.target.value)}
                                            />
                                        </div>
                                        
                                        <div className="form-group">
                                            <label>State:</label>
                                            <input 
                                                type="text" 
                                                value={editedOrderData.billing_state || ''} 
                                                onChange={(e) => handleOrderDataChange('billing_state', e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Pincode:</label>
                                            <input 
                                                type="text" 
                                                value={editedOrderData.billing_pincode || ''} 
                                                onChange={(e) => handleOrderDataChange('billing_pincode', e.target.value)}
                                            />
                                        </div>
                                        
                                        <div className="form-group">
                                            <label>Country:</label>
                                            <input 
                                                type="text" 
                                                value={editedOrderData.billing_country || ''} 
                                                onChange={(e) => handleOrderDataChange('billing_country', e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Payment Method:</label>
                                        <input 
                                            type="text" 
                                            value={editedOrderData.payment_method || ''} 
                                            readOnly
                                        />
                                    </div>
                                    
                                    <h3>Select Items for Return</h3>
                                    {editedOrderData.order_items?.map((item, index) => (
                                        <div key={index} className="order-item">
                                            <div className="item-select">
                                                <input 
                                                    type="checkbox" 
                                                    id={`item-${index}`}
                                                    onChange={(e) => handleItemSelection(item, e.target.checked)}
                                                    checked={selectedItems.some(i => i.sku === item.sku)}
                                                />
                                                <label htmlFor={`item-${index}`}>Select for Return</label>
                                            </div>
                                            
                                            <h4>Item {index + 1}</h4>
                                            <div className="form-row">
                                                <div className="form-group">
                                                    <label>SKU:</label>
                                                    <input 
                                                        type="text" 
                                                        value={item.sku || ''} 
                                                        readOnly
                                                    />
                                                </div>
                                                
                                                <div className="form-group">
                                                    <label>Name:</label>
                                                    <input 
                                                        type="text" 
                                                        value={item.name || ''} 
                                                        readOnly
                                                    />
                                                </div>
                                            </div>
                                            
                                            <div className="form-row">
                                                <div className="form-group">
                                                    <label>Units:</label>
                                                    <input 
                                                        type="number" 
                                                        value={item.units || 0} 
                                                        readOnly
                                                    />
                                                </div>
                                                
                                                <div className="form-group">
                                                    <label>Price:</label>
                                                    <input 
                                                        type="text" 
                                                        value={item.selling_price || ''} 
                                                        readOnly
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    
                                    <div className="selected-items-summary">
                                        <h4>Selected Items: {selectedItems.length}</h4>
                                        <p>Total Value: ₹{selectedItems.reduce((total, item) => total + (parseFloat(item.selling_price) * item.units), 0).toFixed(2)}</p>
                                    </div>
                                </div>
                                
                                <div className="rmodal-footer">
                                    <button className="cancel-btn" onClick={closeModal}>Cancel</button>
                                    <button 
                                        className="save-btn" 
                                        onClick={initiateReturnOrder}
                                        disabled={isSubmitting || selectedItems.length === 0}
                                    >
                                        Create Return Order
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}
            
            {/* Confirmation Modal */}
            {showConfirmModal && (
                <div className="rmodal-overlay">
                    <div className="confirmation-modal">
                        <div className="rmodal-header">
                            <h2>Confirm Return Order</h2>
                            <button className="rclose-btn" onClick={closeConfirmModal}>×</button>
                        </div>
                        <div className="rmodal-body">
                            <div className="cost-breakdown">
                                {/* <h3>Return Order Cost</h3> */}
                                <div className="cost-item">
                                    <span>Return Cost:</span>
                                    {/* <span>₹{RETURN_COST.toFixed(2)}</span> */}
                                    <span> ₹118 (18% tax included)</span>
                                </div>
                                {/* <div className="cost-item">
                                    <span>GST (18%):</span>
                                    <span>₹{(RETURN_COST * TAX_RATE).toFixed(2)}</span>
                                </div>
                                <div className="cost-item total">
                                    <span>Total:</span>
                                    <span>₹{TOTAL_COST.toFixed(2)}</span>
                                </div> */}
                            </div>
                            
                            <div className="wallet-info">
                                <p>Current Wallet Balance: ₹{walletBalance.toFixed(2)}</p>
                                <p>Balance After Deduction: ₹{confirmBalance.toFixed(2)}</p>
                            </div>
                            
                            <p className="confirmation-message">
                                This amount will be deducted from your wallet. Do you want to proceed?
                            </p>
                        </div>
                        <div className="rmodal-footer">
                            <button className="cancel-btn" onClick={closeConfirmModal}>Cancel</button>
                            <button 
                                className="confirm-btn" 
                                onClick={createReturnOrder}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? 'Processing...' : 'Confirm & Create Return'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Return;